import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, mergeMap } from "rxjs/operators";

import { ICustomer } from "../../core/interfaces/customer.interface";

import { ApplicationConstantsEnum } from "../../core/enums/applications-constants.enum";
import { ChannelTypeEnum } from "../../core/enums/chanel.type.enum";
import { OverflowErrorsEnum } from "../../core/enums/overflow-errors.enum";

import { ClientEducationalService } from "./client-educational.service";
import { CustomerService } from "./customer.service";
import { OverflowErrorsService } from "./overflow-errors.service";

import { AuthenticationRemoteService } from "../remote/authentication-remote.service";
import { FileManagerRemoteService } from "../remote/file-manager-remote.service";

@Injectable({
  providedIn: "root",
})
export class FileManagerService {
  fileType: string;

  customer: ICustomer;

  constructor(
    private authenticationRemoteService: AuthenticationRemoteService,
    private clientEducationalService: ClientEducationalService,
    private fileManagerRemoteService: FileManagerRemoteService,
    private customerService: CustomerService,
    private overflowErrorsService: OverflowErrorsService,
  ) {}

  castFileToBase64(file: File): Observable<any> {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    return new Observable((observer: any) => {
      fileReader.onload = () => observer.next(fileReader.result);
      fileReader.onerror = () => {
        observer.error({
          error: {
            code: OverflowErrorsEnum.TECHNICAL_ERROR,
          },
        });
      };
    });
  }

  getFileExtension(file: File) {
    return file.name.lastIndexOf(".") > -1
      ? file.name.substring(file.name.lastIndexOf(".") + 1)
      : "";
  }

  validateFile(file: File): boolean {
    let fileOk: boolean;
    this.fileType = this.getFileExtension(file);

    if (
      this.fileType === ApplicationConstantsEnum.PDF ||
      this.fileType === ApplicationConstantsEnum.JPG ||
      this.fileType === ApplicationConstantsEnum.JPGE
    ) {
      fileOk = file.size <= ApplicationConstantsEnum.MAXIMUM_FILE_SIZE;
    }

    return fileOk;
  }

  sendFile(file: File, channel: ChannelTypeEnum) {
    this.customer = this.customerService.getCustomer();
    const autenticationRemote =
      this.clientEducationalService.getToggleEducational() ||
      this.clientEducationalService.getToggleOptimization()
        ? this.sendFileEducational(channel)
        : this.sendFileTraditional();

    return autenticationRemote.pipe(
      mergeMap((dataAuthentication: any) => {
        this.customer.urlFile = dataAuthentication.urlFile;
        this.customer.obligationId = dataAuthentication.idObligation;
        this.customer.accessToken = dataAuthentication.token;

        this.customerService.setCustomer(this.customer);

        return this.putFile(file);
      }),
      catchError((errorClientEnabled: any) => {
        this.overflowErrorsService.setOverflowError(
          errorClientEnabled.error.code
            ? errorClientEnabled.error.code
            : OverflowErrorsEnum.BucketFile002,
        );

        return throwError([]);
      }),
    );
  }

  private putFile(file: File) {
    return this.castFileToBase64(file).pipe(
      mergeMap((fileToBase64: any) => {
        return this.fileManagerRemoteService.putFile(
          this.customer.urlFile,
          fileToBase64,
          this.fileType,
        );
      }),
      catchError((errorConvertFile: any) => {
        this.overflowErrorsService.setOverflowError(
          errorConvertFile.error.code
            ? errorConvertFile.error.code
            : OverflowErrorsEnum.BucketFile002,
        );

        return throwError([]);
      }),
    );
  }

  private sendFileEducational(channel: ChannelTypeEnum) {
    return this.authenticationRemoteService.getCredentialsForUploadFilesNewClient(
      {
        channel: channel,
        documentNumber: this.customer.documentId.toString(),
        documentType: this.customer.documentType,
        fileExt: this.fileType,
      },
    );
  }

  private sendFileTraditional() {
    return this.authenticationRemoteService.getCredentialsForUploadFiles(
      this.customer.documentType,
      this.customer.documentId,
      this.fileType,
    );
  }
}
